import React from 'react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormTextarea,
  CRow,
} from '@coreui/react-pro'
import { setGiftCategory, submitCreateGiftCategory } from './model'
import { useCreateGiftCategory } from './hooks'
export const CreateGiftCategory = () => {
  const { giftCategory, loading } = useCreateGiftCategory()
  const handleChange = (event: {
    currentTarget: { name: any; type: string; checked?: any; value: any }
  }) => {
    const value =
      event.currentTarget.type === 'checkbox'
        ? event.currentTarget.checked
        : event.currentTarget.value

    setGiftCategory({
      ...giftCategory,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <div>
      <CCard className="mb-4">
        <CCardHeader className="d-sm-flex justify-content-between align-items-center">
          <strong>Create gift category</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="name"
                  name="name"
                  value={giftCategory.name}
                  onChange={handleChange}
                  label="Name"
                />
              </CCol>
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="title"
                  name="title"
                  value={giftCategory.title}
                  onChange={handleChange}
                  label="Title"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={8}>
                <CFormTextarea
                  id="description"
                  name="description"
                  value={giftCategory.description}
                  onChange={handleChange}
                  label="Description"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormCheck
                  id="isShow"
                  name="isShow"
                  checked={giftCategory.isShow}
                  onChange={handleChange}
                  label="Availability to order"
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  type="text"
                  id="sorting"
                  name="sorting"
                  value={giftCategory.sorting}
                  onChange={handleChange}
                  label="Sorting"
                />
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => submitCreateGiftCategory(giftCategory)}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </div>
  )
}
